export const checkFieldValidation = (fieldName, fieldSetting) => {
  const obj = fieldSetting.find(
    (field) => field.formFieldName?.fieldName === fieldName
  );
  return obj ?? null;
};
